import axios from "axios";

const configuredBackendUrl = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");
const runtimeOrigin = typeof window !== "undefined" ? window.location.origin : "";
const BACKEND_URL = configuredBackendUrl || runtimeOrigin;
export const API_BASE = `${BACKEND_URL}/api`;

/**
 * Browser authentication is exclusively via the HttpOnly session cookie.
 * The frontend never handles, reads, or persists the session token.
 *
 * CSRF strategy (PR 3): signed double-submit HMAC token, delivered by
 * GET /api/csrf and kept ONLY in memory (see setCsrfToken below). The
 * axios interceptor attaches it to every mutating request as
 * X-CSRF-Token. The token is never written to localStorage or
 * sessionStorage, never sent on WebSocket URLs and never logged.
 */
const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

let csrfToken = "";

export function setCsrfToken(value) {
  csrfToken = value || "";
}

export function getCsrfToken() {
  return csrfToken;
}

/** Fetch a fresh CSRF token bound to the current (possibly anonymous)
 *  browser session. Call this on app boot and after every auth-state
 *  transition (login, logout, logout-all). */
export async function refreshCsrfToken() {
  const { data } = await api.get("/csrf");
  csrfToken = data.csrf_token || "";
  return csrfToken;
}

const MUTATING = new Set(["post", "put", "patch", "delete"]);

api.interceptors.request.use((config) => {
  const method = (config.method || "get").toLowerCase();
  if (MUTATING.has(method) && csrfToken) {
    config.headers = config.headers || {};
    config.headers["X-CSRF-Token"] = csrfToken;
  }
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Algo deu errado. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
